import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {ProdutosPermitidosRoutingModule} from './produtos-permitidos-routing.module';
import {ProdutosPermitidosPesquisa} from './pesquisa/produtos-permitidos-pesquisa';
import {ProdutosPermitidosListagem} from './listagem/produtos-permitidos-listagem';
import { ModalProdutosPermitidosComponent } from './modal-produtos-permitidos.component';

@NgModule({
  declarations:[
    ProdutosPermitidosPesquisa,
    ProdutosPermitidosListagem,
    ModalProdutosPermitidosComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    NgSelectModule,
    ProdutosPermitidosRoutingModule
  ],
  providers:[]
})
export class ProdutosPermitidosModule{}
